import {
    getApiBaseUrl as getConfiguredApiBaseUrl,
    getApiKey as getConfiguredApiKey,
    toMockErrorResponse,
    toMockResponse,
} from '../apiConfig'
import Mock from '../mock'
import axios from 'axios.js'
const getApiBase = () => getConfiguredApiBaseUrl()
const getApiKey = () => getConfiguredApiKey()

Mock.onGet('/api/site/sync/settings').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=site/sync/settings/get/`)
        return toMockResponse(response)
    } catch (e) {
        console.error('site sync settings get error', e)
        return toMockErrorResponse(e, 'Ошибка получения настроек синхронизации сайта')
    }
})

Mock.onPost('/api/site/sync/settings/save').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=site/sync/settings/save/`, data)
        return toMockResponse(response)
    } catch (e) {
        console.error('site sync settings save error', e)
        return toMockErrorResponse(e, 'Ошибка сохранения настроек синхронизации сайта')
    }
})

Mock.onPost('/api/site/sync/test').reply(async () => {
    try {
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=site/sync/test/`, {})
        return toMockResponse(response)
    } catch (e) {
        console.error('site sync test error', e)
        return toMockErrorResponse(e, 'Ошибка проверки подключения к API сайта')
    }
})

Mock.onPost('/api/site/sync/preview').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=site/sync/preview/`, data)
        return toMockResponse(response)
    } catch (e) {
        console.error('site sync preview error', e)
        return toMockErrorResponse(e, 'Ошибка получения предпросмотра синхронизации сайта')
    }
})

Mock.onPost('/api/site/sync/apply').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=site/sync/apply/`, data)
        return toMockResponse(response)
    } catch (e) {
        console.error('site sync apply error', e)
        return toMockErrorResponse(e, 'Ошибка применения синхронизации сайта')
    }
})

Mock.onPost('/api/site/sync/run-auto').reply(async () => {
    try {
        const response = await axios.post(`${getApiBase()}/?apiKey=${getApiKey()}&route=site/sync/run-auto/`, {})
        return toMockResponse(response)
    } catch (e) {
        console.error('site sync run-auto error', e)
        return toMockErrorResponse(e, 'Ошибка запуска авто-синхронизации сайта')
    }
})

Mock.onGet('/api/site/sync/logs').reply(async () => {
    try {
        const response = await axios.get(`${getApiBase()}/?apiKey=${getApiKey()}&route=site/sync/logs/`)
        return toMockResponse(response)
    } catch (e) {
        console.error('site sync logs error', e)
        return toMockErrorResponse(e, 'Ошибка получения логов синхронизации сайта')
    }
})
